/**
 * The product guides, read from `help/*.md` at the repo root — the same files the MCP server's
 * `search_help` answers from, so the app and the AI assistant tell one story.
 */
const raw_guides = import.meta.glob("../../../help/*.md", { query: "?raw", import: "default", eager: true }) as Record<
  string,
  string
>

export interface HelpGuide {
  slug: string
  title: string
  summary: string
  body: string
}

/** Strip `---` front matter and read `title:` / `summary:` from it. */
export function parse_guide(slug: string, raw: string): HelpGuide {
  let title = slug
  let summary = ""
  let body = raw
  const fm = raw.match(/^---\n([\s\S]*?)\n---\n?/)
  if (fm) {
    body = raw.slice(fm[0].length)
    for (const line of fm[1].split("\n")) {
      const m = line.match(/^(\w+):\s*(.*)$/)
      if (m?.[1] === "title") title = m[2].trim()
      if (m?.[1] === "summary") summary = m[2].trim()
    }
  }
  return { slug, title, summary, body: body.trim() }
}

/** Reading order; anything not listed sorts last (indexOf -1 sorts first, so unknown slugs are pushed to the end explicitly). */
const GUIDE_ORDER = [
  "getting-started",
  "categories-and-gl-codes",
  "coding-deductions",
  "cash-application",
  "open-deductions-and-month-end",
  "short-pays-and-discounts",
  "connections-and-settings",
  "disputes-and-backup",
  "tasks-and-team",
  "ask-ai",
  "api",
]

export const help_guides: HelpGuide[] = Object.entries(raw_guides)
  .map(([path, raw]: [string, string]) => parse_guide(path.replace(/^.*\//, "").replace(/\.md$/, ""), raw))
  .sort((a: HelpGuide, b: HelpGuide) => guide_rank(a.slug) - guide_rank(b.slug))

function guide_rank(slug: string): number {
  const i = GUIDE_ORDER.indexOf(slug)
  return i === -1 ? GUIDE_ORDER.length : i
}


export function find_guide(slug: string): HelpGuide | undefined {
  return help_guides.find((g: HelpGuide) => g.slug === slug)
}
